import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Queries {

  getGroup(): DocumentNode {
    return gql`
    query getOneGroup($id: ID!) {
      group(id: $id) {
        id
        name
        description
        createdAt
        users {
          id
          name
          email
          archived
          type
        }
      }
    }
    `;
  }

  getGroups(): DocumentNode {
    return gql`
    query queryPagedGroups (
        $where: GroupWhereInput,
        $orderBy: GroupOrderByInput,
        $limit: Int,
        $offset: Int
      ) {
        groups(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          totalCount
          items {
            id
            name
            description
            createdAt
            archived
          }
        }
      }
    `;
  }
}
